export function Footer() {
  return (
    <div className="footer">
      <p
        style={{
          marginBottom: "0",
        }}
      >
        Copyright © ikram Website 2021
      </p>
    </div>
  );
}
